import KLARNA_ORDER_ITEM_NAME from '../../constants/klarna-item-name';
import KLARNA_ORDER_ITEM_TYPE from '../../constants/klarna-item-type';
import type { ActiveBasketSummaryData } from '../../typings/basket.types';
import type { KlarnaAuthorizePayload, KlarnaAuthorizePayloadOrderLine } from '../../typings/klarna.types';
import klarnaPriceFormatter from './klarnaPriceFormatter';

const createKlarnaOrderPayload = (
    activeBasketSummary: ActiveBasketSummaryData,
    purchaseCountry: string,
    purchaseCurrency: string,
): KlarnaAuthorizePayload => {
    if (!activeBasketSummary.items) {
        throw new Error('Items array is undefined, cannot initialize Klarna session');
    }

    if (!purchaseCountry) {
        throw new Error('Purchase country is not defined');
    }

    if (!purchaseCurrency) {
        throw new Error('Purchase currency is not defined');
    }

    const basketTotal = klarnaPriceFormatter(activeBasketSummary.totalPrice);
    const basketTax = klarnaPriceFormatter(activeBasketSummary.additionalTaxTotal);
    const items = activeBasketSummary.items.map((item) => {
        const result: KlarnaAuthorizePayloadOrderLine = {
            name: item.name,
            quantity: item.quantity,
            total_amount: item.quantity * klarnaPriceFormatter(item.price),
            unit_price: klarnaPriceFormatter(item.price),
        };
        return result;
    });

    if (basketTax > 0) {
        items.push({
            name: KLARNA_ORDER_ITEM_NAME.SALES_TAX,
            quantity: 1,
            total_amount: basketTax,
            type: KLARNA_ORDER_ITEM_TYPE.SALES_TAX,
            unit_price: basketTax,
        });
    }

    if (activeBasketSummary.promoTotal !== 0) {
        items.push({
            name: KLARNA_ORDER_ITEM_NAME.DISCOUNT,
            quantity: 1,
            total_amount: klarnaPriceFormatter(activeBasketSummary.promoTotal),
            type: KLARNA_ORDER_ITEM_TYPE.DISCOUNT,
            unit_price: klarnaPriceFormatter(activeBasketSummary.promoTotal),
        });
    }

    return {
        order_tax_amount: basketTax,
        order_lines: items,
        purchase_country: purchaseCountry,
        purchase_currency: purchaseCurrency,
        order_amount: basketTotal,
        merchant_reference1: activeBasketSummary.number,
        merchant_reference2: activeBasketSummary.id.toString(),
    };
};

export default createKlarnaOrderPayload;
